import { render, staticRenderFns } from "./TheMyOrdersTableStatus.vue?vue&type=template&id=70235e73&scoped=true"
import script from "./TheMyOrdersTableStatus.vue?vue&type=script&lang=js"
export * from "./TheMyOrdersTableStatus.vue?vue&type=script&lang=js"
import style0 from "./TheMyOrdersTableStatus.vue?vue&type=style&index=0&id=70235e73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70235e73",
  null
  
)

export default component.exports